export default __webpack_public_path__ + "static/media/new-invest-icon.b3aec7d1.jpg";